import React from 'react';
import Button, { ButtonSize, ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import IconSettings from '@zvuk-b2b/react-uikit/ui/icons/Settings';
import IconChevronDown from '@zvuk-b2b/react-uikit/ui/icons/ChevronDown';
import IconChevronUp from '@zvuk-b2b/react-uikit/ui/icons/ChevronUp';
import { DATA_TEST_IDS } from '../consts';
import type { MediafileSettingsTriggerProps } from './types';
import styles from '../index.module.scss';

export const MediafileSettingsTrigger: React.FC<MediafileSettingsTriggerProps> = ({
  id,
  title,
  settings,
  triggerRef,
}) => (
  <Button
    ref={triggerRef}
    elementId={DATA_TEST_IDS.SETTINGS_TRIGGER(id)}
    dataTestId={DATA_TEST_IDS.SETTINGS_TRIGGER_BY_TITLE(title)}
    type={ButtonType.PLAIN}
    size={ButtonSize.SMALL}
    className={styles.settingsTrigger}
    isDisabled={settings.isDisabled}
    aria-controls={settings.panelId}
    aria-expanded={settings.isExpanded}
    onClick={() => {
      if (!settings.isDisabled) settings.onExpandedChange(!settings.isExpanded);
    }}>
    <span
      aria-hidden="true"
      className={styles.settingsIcon}>
      <IconSettings />
    </span>
    <span className={styles.settingsLabel}>{settings.label}</span>
    <span
      aria-hidden="true"
      className={styles.settingsIcon}>
      {settings.isExpanded ? <IconChevronUp /> : <IconChevronDown />}
    </span>
  </Button>
);
